<template>
  <div>
      <div class="ly-card order">
          <div class="nav_car">
              <div class="car">订单管理 &nbsp;&nbsp;&gt;&nbsp;&nbsp;订单详情</div>
              <div class="car"><span>状态:&nbsp;{{ getStatus(detailData.STATUS) }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>下单时间:&nbsp;{{ detailData.UPDATE_TIME }}</span></div>
              <el-button class="car_btn" type="primary" @click="goBack()">返回</el-button>
          </div>
          <div class="detail_content">
              <div class="order_title">基本信息</div>
            <!-- 订单信息 -->
              <div>
                <table class="detail_table">
                    <tr>
                        <td class="td_min">订单状态</td>
                        <td class="td_max">{{ getStatus(detailData.STATUS) }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">订单编号</td>
                        <td class="td_max">{{ detailData.ORDER_NUM }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">支付下单时间</td>
                        <td class="td_max">{{ detailData.UPDATE_TIME }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">咨询师</td>
                        <td class="td_max">{{ detailData.PSYCHIATRIST_NAME }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">联系方式</td>
                        <td class="td_max">{{ detailData.PSYCHIATRIST_MOBILE }}</td>
                    </tr>
                </table>
             </div>
          </div>
          <!-- 购买详情 -->
          <div class="detail_content">
              <div class="order_title">购买详情</div>
              <div>
                <table class="detail_table">
                    <tr>
                        <td class="datail_order">咨询师</td>
                        <td class="datail_order">单价</td>
                        <td class="datail_order">数量</td>
                        <td class="datail_order">实际付款</td>
                        <td class="datail_order">支付时间</td>
                    </tr>
                    <tr>
                        <td class="teacher_avatar">
                            <div><el-avatar shape="square" :size="60" :src="$imgUrl+detailData.PSYCHIATRIST_AVATAR"></el-avatar></div>
                            <div>{{ detailData.PSYCHIATRIST_NAME }}</div>
                        </td>
                        <td class="datail_order">{{ detailData.PAYMENT_AMOUNT }}</td>
                        <td class="datail_order">{{ "1" }}</td>
                        <td class="datail_order">{{ detailData.PAYMENT_AMOUNT_ACTUAL }}</td>
                        <td class="datail_order">{{ detailData.PAYMENT_TIME }}</td>
                    </tr>
                </table>
              </div>
          </div>
          <!-- 咨询用户信息 -->
          <div class="detail_content">
              <div class="order_title">咨询用户详情</div>
              <div>
                <table class="detail_table">
                    <tr>
                        <td class="td_min">咨询用户</td>
                        <td class="td_max">{{ detailData.DISPLAY_NAME }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">联系方式</td>
                        <td class="td_max">{{ detailData.USER_MOBILE }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">地址</td>
                        <td class="td_max">{{ detailData.ADDRESS }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">紧急联系人</td>
                        <td class="td_max">{{ detailData.OTHER_CONTACT_NAME }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">关系</td>
                        <td class="td_max">{{ getRel(detailData.OTHER_CONTACT_REL) }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">紧急联系方式</td>
                        <td class="td_max">{{ detailData.OTHER_CONTACT_MOBILE }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">问题描述</td>
                        <td class="td_max">{{ detailData.PRO_DES }}</td>
                    </tr>
                    <tr>
                        <td class="td_min">期望效果</td>
                        <td class="td_max">{{ detailData.EXPECTED_RES }}</td>
                    </tr>
                </table>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            detailData: {},
            activeName: "first",
            ORDER_ID: 0,
            type: 0,
        }
    },
    mounted() {
        this.ORDER_ID = this.$route.query.ORDER_ID
        this.type = this.$route.query.type
        // 详情信息
        this.getOrderInfo()
    },
    methods: {
        // 返回上一页
        goBack() {
             this.$router.back();
        },
        // 关系转换
        getRel(item) {
            let obj = {
                1:'父母',2:'夫妻',3:'子女',
                4:'情侣',5:'朋友',6: '其他'
            }
            return obj[item]
        },
        // 获取状态
        getStatus(item) {
            let obj = {
                  1: '待付款',
                  2: '待确定',
                  3: '待咨询',
                  4: '待评价',
                  5: '已完成',
                  6: '已取消'
                }
              return obj[item]
        },
        // 获取订单详情信息
        getOrderInfo() {
            this.$axios.post(`orderApiSvr/Order/GetOrderInfoDetail`,{
                orderId: this.ORDER_ID
            }).then(res => {
                if(res.code == 200 || res.code == 0) {
                    this.detailData = res.data
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
 .order {
   height: 850px;
   overflow: auto;
   .detail_content {
        border: 2px solid #f2f2f2;
        margin-bottom: 20px;
        border-radius: 10px;
    }
    .order_title {
        font-weight: 700;
        font-style: normal;
        color: #171C49;
        padding: 0 30px;
        line-height: 45px;
        background-color:rgba(242, 242, 242, 1);
        height: 45px;
        margin-bottom: 10px;
    }
    .detail_table {
        margin: 40px 0 40px 80px;
        min-width: 500px;
        border-collapse: collapse;
        border-spacing: 0px;
        border: none;
        font-size: 16px;
        font-weight: 400;
        font-family: "微软雅黑 Regular";
        text-align: center;
        tr {
            height: 30px;
            font-size: 16px;
            font-weight: 400;
            text-align: left;
            font-family: "微软雅黑 Regular";
            
        }
        td {
            border: 1px solid #e4e4e4;
            height: 35px;
            padding-left: 30px;
            font-size: 16px;
            color: #171C49;
        }
        .td_min {
            min-width: 150px;
        }
        .td_max {
            min-width: 500px;
        }
        .datail_order {
            min-width: 150px;
            padding: 0;
            text-align: center;
        }
        .datail_des {
        width: 80px;
           min-height: 150px;
           display: flex;
        }
       .teacher_avatar {
           min-height: 100px;
           display: flex;
           border-top: none;
           border-right: none;
           width: 200px;
           align-items: center;
           padding-left: 10px;
           .el-avatar {
               margin-right: 10px;
           }
       } 
    }
}
.nav_car {
    display: flex;
    min-height: 80px;
    align-items: center;
    .car {
        height: 40px;
        padding: 0 30px;
        line-height: 40px;
        text-align: center;
        box-shadow: 0px 0px 20px #00000059;
        border-radius: 10px;
        margin-right: 10px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
        font-weight: 700;
        font-style: normal;
        color: #171C49;
        font-size: 14px;
    }
    .car_btn {
        border-radius: 10px;
        box-shadow: 0px 0px 20px #00000059;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/orders/orderDetail.vue